export const GET_TENANT_TEMPLATES_LIST = "/bot/v2/templates"
export const CREATE_TENANT_TEMPLATE = "/bot/v2/templates/createTemplate"
export const UPDATE_TENANT_TEMPLATE = "/bot/v2/templates/updateTemplate"

export const DENY_LIST_ENDPOINT = "/bot/v2/templates/deny-list"